import Util from '@/helper/Utility.js';
import ConfigManager from '@/config/ConfigManager';
import { AddressListModel } from "@/core/Address/model/AddressListModel.js";
import { locationModel } from "./LocationModel.js";

export function DeliveryMethodModel() {
    this.address = null;
    this.category = "nationwide";
    this.deliverTime = null;
    this.deliveryMethod = "Delivery";
    this.limitOrder = false;
    this.location = null;
    this.orderPlan = null;

    this.setDeliveryMethod = function(deliveryMethod) {
        this.deliveryMethod = deliveryMethod
    }

    this.setValueFormApi = function(dict) {
        this.address = null;
        if (dict.Address) {
            var addr = new AddressListModel();
            addr.setValueFormApi(dict.Address);
            this.address = addr;
        }
        this.category = dict.Category;
        this.deliverTime = dict.DeliverTime;
        this.deliveryMethod = dict.DeliveryMethod;
        this.limitOrder = dict.LimitOrder;
        this.location = null;
        if (dict.Location) {
            var loc = new locationModel();
            loc.setValueFormApi(dict.Location);
            this.location = loc;
        }
        this.orderPlan = dict.OrderPlan;
    }

    this.setValueFormCache = function(dict) {
        this.address = null;
        if (dict.address) {
            var addr = new AddressListModel();
            addr.setValueFormCache(dict.address);
            this.address = addr;
        }
        this.category = dict.category;
        this.deliverTime = dict.deliverTime;
        this.deliveryMethod = dict.deliveryMethod;
        this.limitOrder = dict.limitOrder;
        this.location = null;
        if (dict.location) {
            var loc = new locationModel();
            loc.setValueFormCache(dict.location);
            this.location = loc;
        }
        this.orderPlan = dict.orderPlan;
    }

    this.getParams = function() {
        var params = {}
        if (this.deliveryMethod == "Delivery") {
            params = {
                deliveryMethod: this.deliveryMethod,
                addressKey: this.address.rowKey,
                device_app_id: ConfigManager.getAppId(),
                delivertime: this.deliverTime
            };
        } else {
            params = {
                deliveryMethod: this.deliveryMethod,
                center: this.location.latitude + ',' + this.location.longtitude,
                locationId: this.location.id,
                orderPlan: this.orderPlan,
                device_app_id: ConfigManager.getAppId(),
                delivertime: this.deliverTime
            };
        }
        params = Util.cleanObjectEmptyStr(params);
        return params
    };
}

export function PermissionDeliveryModel(dict) {
    this.disableGuestDelivery = dict.DisableGuestDelivery;
    this.disableGuestInstore = dict.DisableGuestInstore;
    this.disableMemberDelivery = dict.DisableMemberDelivery;
    this.disableMemberInstore = dict.DisableMemberInstore;
}